<kilowant-header [isBuyer]="true" [showAccountList]="false" [title]="(welcomeText)?'Welcome to kilowant':'Add Account'"></kilowant-header>
<div class="overWrapper">
    @if (!preRegisteredAccountUpdateMode) {
    <div class="wrapperMain mt-40">
        @if (welcomeText) {
        <div class="form buyer mb-10">You're on the path to finding energy at the price you want. Please complete the three steps below for each of your utility accounts, and we will then match you with today's top offers.</div>
        }
    </div>
    }
    <ol class="wrapperMain kilowant-list">
        <li class="home-step" [class]="(step==1)?'':('inactive'+((step>1)?' with-link':''))" #step1>
            <h3 class="title" #body>
                <span>Upload or Photo P.1 of your Bill</span>
            </h3>
            @if (step>1) {
            <div class="inactive-step" (click)="gotoStep(1)"></div>
            }
            @if (step==1) {
            <div class="form">
                <div class="body" #body>
                    @if (account) {
                    <div class="bill-photo"></div>
                    @if (!loading && !progress) {
                    <div class="progress-tabs">
                        <label class="i_upload link"><br />Upload<input style="display: none;" type="file" name="billImage" class="required" value="" placeholder="Bill Image" (change)="handleFileInput($event)" /></label>
                        <label class="i_camera link"><br />Photo<input type="file" capture="camera" accept="image/*" name="billImage" style="display: none;" value="" placeholder="Bill Image File" (change)="handleFileInput($event)" /></label>
                    </div>
                    }
                    @if (loading || progress) {
                    <div class="progress-bar">
                        <div class="bar">
                            <span class="progress" [style]="'width: '+progressWidth+'%'"></span>
                        </div>
                    </div>
                    }
                    }
                </div>
                <div>&nbsp;</div>
                @if (errorY().showError()) {
                <div class="error-block">{{errorY().error}}</div>
                }
            </div>
            }
        </li>
        <li class="home-step" [class]="(step==2)?'':('inactive'+((step>2)?' with-link':''))" #step2>
            <h3>Complete Account Details</h3>
            @if (step>2) {
            <div class="inactive-step" (click)="gotoStep(2)"></div>
            }
            @if (step==2) {
            <div class="form">
                <div class="body">
                    <div class="mb-25">
                        @if (imageMode==0 || imageMode==2) {
                        <div>
                            <select [class]="getClassesForInput('utilityId', true, (account.utility==null)?null:account.utility.name)" [disabled]="disableSelectorOfUtilityData" name="utilityId" [(ngModel)]="utilityId" (change)="resetError('utilityId'); reloadSelects();">
                                @if (utilityId==0) {
                                <option [selected]="true" [disabled]="true">Utility</option>
                                }
                                @for (utility of utilities; track utility) {
                                <option [ngValue]="utility.id">{{utility.name}}</option>
                                }
                            </select>
                            @if (getVisibilityForLabel((account.utility==null)?null:account.utility.name) || utilityId==-1) {
                            <div class="placeholder">
                                Utility
                            </div>
                            }
                            @if (utilityId!=-1) {
                            <div>
                                @if (account.utility!=null && account.utility.id!=generalService.BETA_UTILITY_ID) {
                                <div>
                                    Unfortunately your account involves an utility distribution company that falls outside of our program. We will save the Account and notify you when kilowant becomes active in your location.
                                </div>
                                }
                                <select [class]="getClassesForInput('loadZoneId', true, (account.loadZone==null)?null:account.loadZone.id+'')"
                                        [disabled]="disableSelectorOfUtilityData"
                                        [compareWith]="compareFn"
                                        name="loadZoneId"
                                        (change)="resetError('loadZoneId');"
                                        [(ngModel)]="account.loadZone">
                                    @if (account.loadZone==null) {
                                    <option [ngValue]="null" [disabled]="true">Load Zone</option>
                                    }
                                    @for (loadZone of loadZones; track loadZone) {
                                    <option [ngValue]="loadZone">{{loadZone.name}}</option>
                                    }
                                </select>
                                @if (getVisibilityForLabel((account.loadZone==null)?null:account.loadZone.id+'')) {
                                <div class="placeholder">Load Zone</div>
                                }
                                <select [class]="getClassesForInput('rateClassId', true, (account.rateClass==null)?null:account.rateClass.name)"
                                        [compareWith]="compareFn"
                                        [disabled]="disableSelectorOfUtilityData"
                                        name="rateClassId"
                                        (change)="resetError('rateClassId');"
                                        [(ngModel)]="account.rateClass">
                                    @if (account.rateClass==null) {
                                    <option [ngValue]="null" [disabled]="true">Rate Class</option>
                                    }
                                    @for (rateClass of rateClasses; track rateClass) {
                                    <option [ngValue]="rateClass">{{rateClass.name}}</option>
                                    }
                                </select>
                                @if (getVisibilityForLabel((account.rateClass==null)?null:account.rateClass.name)) {
                                <div class="placeholder">Rate Class</div>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (account.utility) {
                        <div>
                            <input type="text"
                                   #serviceName
                                   name="serviceName"
                                   [class]="getClassesForInput('serviceName', true, account.serviceName)"
                                   (input)="resetError('serviceName')"
                                   autocomplete="off"
                                   placeholder="Customer Name"
                                   [(ngModel)]="account.serviceName"
                                   [minlength]="validationService.getMinLength('Account', 'serviceName')"
                                   [maxlength]="validationService.getMaxLength('Account', 'serviceName')" />
                            @if (getVisibilityForLabel(account.serviceName)) {
                            <div class="placeholder">Customer Name</div>
                            }
                            <div class="right-margin-icon info-icon after-placeholder cursor-pointer" (click)="openExampleDialog(false)"></div>
                            <input type="text"
                                   name="address"
                                   [class]="getClassesForInput('addressLine1', true, account.addressLine1)"
                                   (input)="resetError('addressLine1')"
                                   placeholder="Service Address"
                                   [(ngModel)]="account.addressLine1"
                                   [minlength]="validationService.getMinLength('Account', 'address')"
                                   [maxlength]="validationService.getMaxLength('Account', 'address')" />
                            @if (getVisibilityForLabel(account.addressLine1)) {
                            <div class="placeholder">Service Address</div>
                            }
                            <input type="text"
                                   name="address"
                                   [class]="getClassesForInput('addressLine2', true, account.addressLine2)"
                                   (input)="resetError('addressLine2')"
                                   placeholder="Address Line 2"
                                   [(ngModel)]="account.addressLine2"
                                   [minlength]="0"
                                   [maxlength]="validationService.getMaxLength('Account', 'address')" />
                            @if (getVisibilityForLabel(account.addressLine2)) {
                            <div class="placeholder">Address Line 2</div>
                            }
                            <div class="cols">
                                <div class="col">
                                    <select [class]="getClassesForInput('stateId', true, 'ST')"
                                            [compareWith]="compareFn"
                                            name="stateId"
                                            style="width: 60px !important;"
                                            (change)="resetError('stateId');"
                                            [(ngModel)]="account.state">
                                        @if (account.state==null) {
                                        <option [ngValue]="null" [disabled]="true">ST</option>
                                        }
                                        @for (state of states; track state) {
                                        <option [ngValue]="state">{{state.stateCode}}</option>
                                        }
                                    </select>
                                    @if (getVisibilityForLabel((account.state==null)?null:account.state.name)) {
                                    <div class="placeholder">State</div>
                                    }
                                </div>
                                <div class="col">
                                    <select [class]="getClassesForInput('city', true, account.city)"
                                            name="city"
                                            (change)="resetError('city');"
                                            [(ngModel)]="account.city">
                                        @if (account.city==null) {
                                        <option [ngValue]="null" [disabled]="true">City</option>
                                        }
                                        @for (city of cities; track city) {
                                        <option [ngValue]="city">{{city}}</option>
                                        }
                                    </select>
                                    @if (getVisibilityForLabel(account.city)) {
                                    <div class="placeholder">City</div>
                                    }
                                </div>
                                <div class="col">
                                    <input type="text"
                                           name="address"
                                           [class]="getClassesForInput('zip', true, account.zip)"
                                           (input)="resetError('zip')"
                                           placeholder="Zip"
                                           [(ngModel)]="account.zip"
                                           [minlength]="validationService.getMinLength('Account', 'zip')"
                                           [maxlength]="validationService.getMaxLength('Account', 'zip')" />
                                    @if (getVisibilityForLabel(account.zip)) {
                                    <div class="placeholder">Zip</div>
                                    }
                                </div>
                            </div>
                            <input type="text"
                                   name="accountNumber"
                                   (input)="resetError('accountNumber')"
                                   placeholder="Account number"
                                   [formControl]="currentAccountNumber"
                                   [dropSpecialCharacters]="false"
                                   [mask]="(account.utility.accountTemplate!=null)?account.utility.accountTemplate:'0000000000'"
                                   (focus)="focusField('accountNumber')"
                                   (focusout)="focusOutField('accountNumber');"
                                   [showMaskTyped]="(focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))"
                                   [class]="getClassesForInput('accountNumber', true, ((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())) + ((focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))?' ls-5':'')" />
                            @if (getVisibilityForLabel(((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())+((focusedField()=='accountNumber')?'account':''))) {
                            <div class="placeholder">Account number</div>
                            }
                            <input type="text"
                                   name="keyName"
                                   [class]="getClassesForInput('keyName', true, account.keyName)"
                                   (input)="resetError('keyName')"
                                   placeholder="Shopping ID"
                                   [(ngModel)]="account.keyName"
                                   [minlength]="validationService.getMinLength('Account', 'keyName')"
                                   [maxlength]="validationService.getMaxLength('Account', 'keyName')" />
                            @if (getVisibilityForLabel(account.keyName)) {
                            <div class="placeholder">Shopping ID</div>
                            }

                            <div class="mb-10">
                                <label><input type="checkbox" value="1" [checked]="isCommercial()" [disabled]="this.account.rateClass?.isCommercial" (change)="changeCommercial()" /> Account is commercial</label>
                            </div>
                            @if (isCommercial()) {
                            @if(!newCompanyRegistration()) {
                            <div>
                                <select name="company" [class]="getClassesForInput('companyName', true, null)+' placeholder'" [compareWith]="compareFn" [(ngModel)]="account.company" (change)="resetError('companyName'); selectExistingCompany()">
                                    <option [ngValue]="null" [disabled]="true">Select Company</option>
                                    @for (company of userCompanies; track company) {
                                    <option [ngValue]="company">{{company.name}}</option>
                                    }
                                </select>
                                <div class="placeholder" style="text-align: right; padding-right: 28px;"><a (click)="setNewCompany()">Add New Company</a></div>
                            </div>
                            }
                            @if(newCompanyRegistration()) {
                            <div>
                                <input type="text" name="companyName" [class]="getClassesForInput('companyName', true, account.company!.name)" placeholder="Company Name" (input)="resetError('companyName')" [(ngModel)]="account.company!.name" />
                                @if (getVisibilityForLabel(account.company!.name)) {
                                <div class="placeholder">Company Name</div>
                                }
                                @if (this.userCompanies!=null && this.userCompanies.length>0) {
                                <div style="text-align: right; font-size: 13px; margin-top: -5px;"><a (click)="switchToCompanySelect();">Select from existing companies</a></div>
                                }
                            </div>
                            }
                            <div>
                                <div class="mb-10 mt-10">
                                    <label>
                                        <input type="checkbox" name="taxExempt" (change)="taxExemptChanged()" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" [(ngModel)]="taxExempt" /> Is your business
                                        tax exempt?
                                    </label>
                                </div>
                                @if (account.company!=null && taxExempt && account.company.taxExempt) {
                                <div>
                                    <input type="text" name="FederalTaxID" class="w-100"
                                           [class]="getClassesForInput('FederalTaxID', true, account.company.federalTaxID)" value=""
                                           (input)="resetError('FederalTaxID')" [(ngModel)]="account.company.federalTaxID"
                                           [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()"
                                           placeholder="Federal Tax ID" />
                                    @if (getVisibilityForLabel(account.company.federalTaxID)) {
                                    <div class="placeholder">Federal Tax ID</div>
                                    }
                                    <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                                    @if ((fileToUpload==null) && account.company.taxExemptCertificateDocument==null) {
                                    <label class="formLabel"
                                           [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                                        CHOOSE FILES
                                        <span>no files selected</span>
                                        <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                               placeholder="Tax Exempt Certificate Document" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" (change)="handleFileInput($event)" />
                                    </label>
                                    }
                                    @if (fileToUpload!=null || account.company.taxExemptCertificateDocument!=null) {
                                    <div class="files-list">
                                        <span>File selected</span>
                                        <ul>
                                            @if (account.company.taxExemptCertificateDocument!=null) {
                                            <li>
                                                @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                                                <a (click)="deleteExistingFile(account.company.taxExemptCertificateDocument.key)"></a>
                                                }
                                                <div class="link" (click)="downloadFile(true, account.company.taxExemptCertificateDocument.key)">{{account.company.taxExemptCertificateDocument.value}}</div>
                                            </li>
                                            }
                                            @if (fileToUpload!=null) {
                                            <li>
                                                @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                                                <a (click)="deleteFile()"></a>
                                                }
                                                <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                                            </li>
                                            }
                                        </ul>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (errorY().showError() && errorY().error!='accountissue') {
                        <div class="error-block">{{errorY().error}}</div>
                        }
                        @if (errorY().showError() && errorY().error=='accountissue') {
                        <div class="error-block">The account number you entered is already in use. Please verify the number and try again. If you believe that your account number has been used without your authorization, please <a (click)="reportAccountIssue()">click here</a> to report it to kilowant for investigation.</div>
                        }
                    </div>
                </div>
                <div class="block-buttons full-width under-card">
                    <button type="button" (click)="goToStart()">Back</button>
                    <button type="button" class="highlighted-button" (click)="nextStep();">Next</button>
                </div>
                <div>&nbsp;</div>
            </div>
            }
        </li>

        <li class="home-step" [class]="(step==3)?'':('inactive'+((step>3)?' with-link':''))" #step3>
            <h3>Confirm Supply Service Provider</h3>
            @if (step==3) {
            <div class="form">
                <div class="body mb-25">
                    <div class="supply-plan-confirm">
                        <div>
                            <label>
                                <input type="radio" name="isCommunity" value="0" (click)="errorY().clear(); existingContractId=0" [(ngModel)]="setStartingContract" />Rhode Island Energy
                                @if (utilityRate!=null && utilityRate>0) {
                                <span style="margin-left: 0"> &#64; {{utilityRate | currency:'USD':'symbol':'1.5-5'}}/kWh</span>
                                }<br />
                                <span>Month to Month</span>
                            </label>
                        </div>
                        @if (communityRate!=null && communityRate>0) {
                        <div>
                            <label>
                                <input type="radio" name="isCommunity" value="1" (click)="errorY().clear(); existingContractId=0" [(ngModel)]="setStartingContract" />NextEra Energy &#64; {{communityRate | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
                                <span>Month to Month</span>
                            </label>
                        </div>
                        }
                        @for (existingContract of existingContracts; track existingContract) {
                        <div>
                            <label>
                                <input type="radio" name="existingContractId" (click)="errorY().clear(); setStartingContract=-1" [value]="existingContract.id" [(ngModel)]="existingContractId" />{{existingContract.supplierName}} &#64; {{existingContract.price | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
                                <span>{{existingContract.termFrom | date:'shortDate'}} to {{existingContract.termTo | date:'shortDate'}}</span>
                            </label>
                        </div>
                        }
                        <div><label><input type="radio" name="existingContractId" value="-1" (click)="errorY().clear(); setStartingContract=-1" [(ngModel)]="existingContractId" />Other supplier</label></div>
                    </div>
                    @if (existingContractId==-1) {
                    <div>
                        <input type="text" [class]="getClassesForInput('currentSupplierName', true, existingContract.supplierName)" name="currentSupplierName" [(ngModel)]="existingContract.supplierName" (input)="resetError('currentSupplierName')" placeholder="Supplier Name" maxlength="50" />
                        @if (getVisibilityForLabel(existingContract.supplierName)) {
                        <div class="placeholder">Supplier Name</div>
                        }
                        <input type="text" [class]="getClassesForInput('currentSupplierPrice', true, (existingContract.price==null)?null:''+existingContract.price)" name="currentSupplierPrice" [(ngModel)]="existingContract.price" (input)="resetError('currentSupplierPrice')"
                               (focus)="focusField('currentSupplierPrice')" (focusout)="focusOutField('currentSupplierPrice')" [placeholder]="(focusedField()=='currentSupplierPrice')?'0.00000':'Price $/kWh'" [allowNegativeNumbers]="false" mask="separator.5" thousandSeparator="" />
                        @if (getVisibilityForLabel((existingContract.price==null)?null:''+existingContract.price)) {
                        <div class="placeholder">Price $/kWh</div>
                        }
                        <input matInput [matDatepicker]="picker1" [formControl]="termFrom" (click)="picker1.open(); resetError('termFrom');" [class]="getClassesForInput('termFrom', true, (termFrom.value==null)?null:termFrom.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilter" placeholder="Service Start, 1st meter read on or after">
                        <mat-datepicker #picker1 startView="multi-year" (yearSelected)="chosenYearHandler($event, termFrom)" (monthSelected)="chosenMonthHandler($event, termFrom, 'termFrom', picker1)"></mat-datepicker>
                        @if (getVisibilityForLabel((termFrom.value==null)?null:termFrom.value.toString())) {
                        <div class="placeholder">Service Start, 1st meter read on or after</div>
                        }
                        <input matInput [matDatepicker]="picker2" [formControl]="termTo" (click)="picker2.open(); resetError('termTo');" [class]="getClassesForInput('termTo', true, (termTo.value==null)?null:termTo.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilterTermTo" placeholder="Service End, 1st meter read on or after">
                        <mat-datepicker #picker2 startView="multi-year" (yearSelected)="chosenYearHandler($event, termTo)" (monthSelected)="chosenMonthHandler($event, termTo, 'termTo', picker2)">
                        </mat-datepicker>
                        @if (getVisibilityForLabel((termTo.value==null)?null:termTo.value.toString())) {
                        <div class="placeholder">Service End, 1st meter read on or after</div>
                        }
                    </div>
                    }
                    @if (this.errorY().showError()) {
                    <div class="error-block">{{errorY().error}}</div>
                    }
                </div>
                <div class="block-buttons full-width under-card mb-20">
                    <button type="button" (click)="goBack()">Cancel</button>
                    <button type="button" class="highlighted-button" appOneClick (click)="nextStep()">Submit</button>
                </div>
            </div>
            }
        </li>
    </ol>
</div>